"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validation_exception_1 = require("./exceptions/validation-exception");
const is_validation_result_1 = require("./type-guards/is-validation-result");
/**
 * Validates a given value against some set of validation procedures. If all procedures pass, the object will be asserted to the given type
 * and returned.
 * @template T
 * @param value
 * @param {ValidateFunction} validator
 * @param {...ValidateFunction} additionalValidators
 * @returns {T}
 */
exports.validateType = (value, validator, ...additionalValidators) => {
    const validators = [validator].concat(additionalValidators);
    for (const validate of validators) {
        const result = validate(value);
        if (is_validation_result_1.isValidationResult(result) && !result.valid) {
            throw new validation_exception_1.ValidationException(result.details);
        }
        else if (result === false) {
            throw new validation_exception_1.ValidationException(`'${value}' is not valid.`);
        }
    }
    return value;
};
//# sourceMappingURL=validate-type.js.map